export default __webpack_public_path__ + "Raleway-Bold.ttf?757abe402eb07a0ab73995626b251b87";